import React from 'react';
import { MGServices } from '../MGServices';
import AdminLinkIP from './AdminLinkIP';

// Players, Scores, and Logins all extend the same server-side IPData base class, so they all
// carry the same geo-IP fields (looked up once per network prefix into ip_api_cache) - one
// shared block of table rows instead of re-writing the same fields on every admin single-record
// view. Renders as a run of <tr> rows, meant to be dropped inside an existing <table>.
const IPInfo = ({ rec }) => {
  if (!rec) {
    return null;
  }
  const hasLatLon = typeof rec.lat === 'number' && typeof rec.lon === 'number' &&
    (rec.lat !== 0 || rec.lon !== 0);
  const mapQuestUrl = hasLatLon ? `https://www.mapquest.com/latlng/${rec.lat},${rec.lon}` : null;

  return (
    <>
      <tr>
        <th>IP</th>
        <td>
          {rec.ip}
          <AdminLinkIP val={rec.ip} />
        </td>
      </tr>
      <tr>
        <th>Country</th>
        <td>{rec.countryCode ? `${MGServices.getCountryName(rec.countryCode)} (${rec.countryCode})` : 'Unknown'}</td>
      </tr>
      <tr>
        <th>Region</th>
        <td>{rec.regionName ? `${rec.regionName} (${rec.region})` : 'Unknown'}</td>
      </tr>
      <tr>
        <th>City</th>
        <td>{rec.city || 'Unknown'}</td>
      </tr>
      <tr>
        <th>ISP</th>
        <td>{rec.isp || 'Unknown'}</td>
      </tr>
      <tr>
        <th>Coordinates</th>
        <td>
          {hasLatLon ? (
            <a href={mapQuestUrl} target="_blank" rel="noopener noreferrer">
              {rec.lat}, {rec.lon}
            </a>
          ) : (
            'Unknown'
          )}
        </td>
      </tr>
      <tr>
        <th>Proxy/VPN</th>
        <td style={rec.proxy === 1 ? { color: 'red' } : undefined}>{rec.proxy === 1 ? 'Yes' : 'No'}</td>
      </tr>
      <tr>
        <th>Hosting/Datacenter</th>
        <td style={rec.hosting === 1 ? { color: 'red' } : undefined}>{rec.hosting === 1 ? 'Yes' : 'No'}</td>
      </tr>
    </>
  );
};

export default IPInfo;
